import type { RatingStyleEnum } from '@frameio/graphql-client/generated';
import type { RatingProps } from '@frameio/vapor';
import {
  IconHeart,
  IconHeartFill,
  IconStar,
  IconStarFill,
  IconThumbsUp,
  IconThumbsUpFill,
} from '@frameio/vapor-icons';

type RatingIcons = Pick<RatingProps, 'Icon' | 'IconOutline'>;

export const iconByRatingStyle: Record<RatingStyleEnum, RatingIcons> = {
  HEART: {
    Icon: IconHeartFill,
    IconOutline: IconHeart,
  },
  STAR: {
    IconOutline: IconStar,
    Icon: IconStarFill,
  },
  THUMBS_UP: {
    IconOutline: IconThumbsUp,
    Icon: IconThumbsUpFill,
  },
};
